// src/pages/AboutUsPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const AboutUsPage = () => {
  return (
    <>
      {/* Page Title Section */}
      <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
        <div className="container">
          <h1 className="entry-title title">About us</h1>
          <nav className="wd-breadcrumbs">
            <span typeof="v:Breadcrumb">
              <Link to="/" rel="v:url" property="v:title">Home</Link>
            </span>
            <span className="wd-delimiter"></span>
            <span className="wd-last">About us</span>
          </nav>
        </div>
      </div>

      {/* Main Content Area for About Us */}
      <div className="wd-page-content main-page-wrapper">
        <main className="wd-content-layout content-layout-wrapper container" role="main">
          <div className="wd-content-area site-content">
            <article id="post-205" className="entry-content post-205 page type-page status-publish hentry">
              <div data-elementor-type="wp-page" data-elementor-id="205" className="elementor elementor-205">
                {/* About imw-edu Section */}
                <div className="elementor-element elementor-element-81cd1ab e-con-full wd-section-stretch e-flex e-con e-parent e-lazyloaded" data-id="81cd1ab" data-element_type="container">
                  <div className="elementor-element elementor-element-69aeff8 e-con-full e-flex e-con e-child" data-id="69aeff8" data-element_type="container">
                    <div className="elementor-element elementor-element-434b795 elementor-widget elementor-widget-wd_image_or_svg" data-id="434b795" data-element_type="widget" data-widget_type="wd_image_or_svg.default">
                      <div className="elementor-widget-container">
                        <div className="wd-image text-left">
                          <img
                            fetchpriority="high"
                            decoding="async"
                            width="785"
                            height="524"
                            src="images/realistic-back-school-sales.png"
                            className="attachment-full size-full"
                            alt="Realistic Back School Sales"
                            srcSet="images/realistic-back-school-sales.png 785w, images/realistic-back-school-sales.png 300w, images/realistic-back-school-sales.png 768w"
                            sizes="(max-width: 785px) 100vw, 785px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="elementor-element elementor-element-e313339 e-con-full e-flex e-con e-child" data-id="e313339" data-element_type="container">
                    <div className="elementor-element elementor-element-eaca409 wd-animation-slide-from-bottom wd-width-100 wd-animation-normal elementor-widget elementor-widget-wd_title" data-id="eaca409" data-element_type="widget" data-widget_type="wd_title.default">
                      <div className="elementor-widget-container">
                        <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-default wd-title-style-default wd-title-size-large text-left">
                          <div className="liner-continer">
                            <h4 className="woodmart-title-container title wd-fontsize-xxl wd-underline-colored">About <u>imw-edu</u></h4>
                          </div>
                          <div className="title-after_title reset-last-child wd-fontsize-s">
                            <p>imw-education is a leading provider of innovative educational solutions designed to empower learners of all ages. We combine modern pedagogy with cutting-edge technology to deliver engaging, personalized learning experiences. Our platform supports educators with powerful tools, real-time analytics, and curriculum-aligned content. From foundational subjects to advanced skill-building, we make learning accessible, inclusive, and future-ready. imw-education fosters critical thinking, creativity, and a lifelong love of learning. Trusted by institutions worldwide, we’re transforming how education is delivered and experienced. At imw-education, we don’t just teach—we inspire the next generation of leaders.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-c782319 elementor-widget elementor-widget-wd_button" data-id="c782319" data-element_type="widget" data-widget_type="wd_button.default">
                      <div className="elementor-widget-container">
                        <div className="wd-button-wrapper text-left">
                          <a className="btn btn-style-default btn-shape-rectangle btn-size-default btn-color-primary btn-icon-pos-right" href="#">
                            <span className="wd-btn-text" data-elementor-setting-key="text">Read more</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Hands On Training Section */}
                <section
                  className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-150cf801 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="150cf801" data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-56b46451" data-id="56b46451" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-75e599b8 wd-width-100 elementor-widget elementor-widget-wd_title" data-id="75e599b8" data-element_type="widget" data-widget_type="wd_title.default">
                          <div className="elementor-widget-container">
                            <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-default wd-title-style-default wd-title-size-large text-center">
                              <div className="title-subtitle subtitle-color-default subtitle-style-default wd-fontsize-xs">
                                SEE OUR BEST
                              </div>
                              <div className="liner-continer">
                                <h4 className="woodmart-title-container title wd-fontsize-xxl">HANDS ON TRAINING - PLACEMENT - STARTUP INCUBATION - PRODUCT DEVELOPMENT</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                {/* Info Boxes Section */}
                <section
                  className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-181a974b wd-section-stretch elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="181a974b" data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-default">
                    {/* Education Info Box */}
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3980be1b" data-id="3980be1b" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-377844b1 elementor-widget elementor-widget-wd_infobox" data-id="377844b1" data-element_type="widget" data-widget_type="wd_infobox.default">
                          <div className="elementor-widget-container">
                            <div className="info-box-wrapper">
                              <div className="wd-info-box text-left box-icon-align-left box-style-base color-scheme- wd-items-middle with-btn box-btn-hover">
                                <div className="box-icon-wrapper box-with-text text-size-large box-icon-simple">
                                  <div className="info-box-icon">01.</div>
                                </div>
                                <div className="info-box-content">
                                  <h4 className="info-box-title title box-title-style-default wd-fontsize-m" data-elementor-setting-key="title">Education</h4>
                                  <div className="info-box-inner reset-last-child" data-elementor-setting-key="content"></div>
                                  <div className="info-btn-wrapper">
                                    <div className="wd-button-wrapper text-left">
                                      <a className="btn btn-style-link btn-shape- btn-size-default btn-color-primary btn-icon-pos-right" href="#">
                                        <span className="wd-btn-text" data-elementor-setting-key="text">READ MORE</span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Best Info Box */}
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-caa00" data-id="caa00" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-c8451b9 elementor-widget elementor-widget-wd_infobox" data-id="c8451b9" data-element_type="widget" data-widget_type="wd_infobox.default">
                          <div className="elementor-widget-container">
                            <div className="info-box-wrapper">
                              <div className="wd-info-box text-left box-icon-align-left box-style-base color-scheme- wd-items-middle with-btn box-btn-hover">
                                <div className="box-icon-wrapper box-with-text text-size-large box-icon-simple">
                                  <div className="info-box-icon">02.</div>
                                </div>
                                <div className="info-box-content">
                                  <h4 className="info-box-title title box-title-style-default wd-fontsize-m" data-elementor-setting-key="title">Best</h4>
                                  <div className="info-box-inner reset-last-child" data-elementor-setting-key="content"></div>
                                  <div className="info-btn-wrapper">
                                    <div className="wd-button-wrapper text-left">
                                      <a className="btn btn-style-link btn-shape- btn-size-default btn-color-primary btn-icon-pos-right" href="#">
                                        <span className="wd-btn-text" data-elementor-setting-key="text">READ MORE</span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Launch Info Box */}
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-690ad4b3" data-id="690ad4b3" data-element_type="column">
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-2acab471 elementor-widget elementor-widget-wd_infobox" data-id="2acab471" data-element_type="widget" data-widget_type="wd_infobox.default">
                          <div className="elementor-widget-container">
                            <div className="info-box-wrapper">
                              <div className="wd-info-box text-left box-icon-align-left box-style-base color-scheme- wd-items-middle with-btn box-btn-hover">
                                <div className="box-icon-wrapper box-with-text text-size-large box-icon-simple">
                                  <div className="info-box-icon">03.</div>
                                </div>
                                <div className="info-box-content">
                                  <h4 className="info-box-title title box-title-style-default wd-fontsize-m" data-elementor-setting-key="title">Launch</h4>
                                  <div className="info-box-inner reset-last-child" data-elementor-setting-key="content"></div>
                                  <div className="info-btn-wrapper">
                                    <div className="wd-button-wrapper text-left">
                                      <a className="btn btn-style-link btn-shape- btn-size-default btn-color-primary btn-icon-pos-right" href="#">
                                        <span className="wd-btn-text" data-elementor-setting-key="text">READ MORE</span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </article>
          </div>
        </main>
      </div>
    </>
  );
};

export default AboutUsPage;
